/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Elsewhere_ProcessInputs */

const en_contact_elsewhere_process = /** @type {(inputs: Contact_Elsewhere_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how an engagement runs`)
};

const lv_contact_elsewhere_process = /** @type {(inputs: Contact_Elsewhere_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apskatīt, kā norit sadarbība`)
};

/**
* | output |
* | --- |
* | "See how an engagement runs" |
*
* @param {Contact_Elsewhere_ProcessInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_elsewhere_process = /** @type {((inputs?: Contact_Elsewhere_ProcessInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Elsewhere_ProcessInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_elsewhere_process(inputs)
	return en_contact_elsewhere_process(inputs)
});